<template>
	<div class="photo-previewer-page" :class="{ focus: focusMode }">
		<template v-if="!!car">
			<div class="top-area">
				<nio-header-nav position="relative" v-if="$isInWebview" @back="handleClose" />

				<div class="tabs-container" ref="tabContainer">
					<div
						v-for="(tab, index) in imageMap"
						@click="onClickTab(index)"
						class="tab-item"
						:class="{ cur: index === curTab }"
					>
						{{ tab.name }}（{{ tab.child.length }}）
					</div>
				</div>
			</div>

			<van-swipe
				:loop="false"
				:show-indicators="false"
				ref="swiper"
				class="preview-swiper"
				@change="onSwipe"
			>
				<van-swipe-item v-for="item in flatImage">
					<div class="previewer-container" @click="focusMode = !focusMode">
						<nio-image
							style="width: 100%;"
							loaderHeight="375px"
							:src="cdn(item.image, '/thumbnail/!1200x1200r', true)"
						/>
					</div>
				</van-swipe-item>
			</van-swipe>

			<float-bottom class="gallery-container">
				<div class="photo-desc">
					{{ imageMap[curTab].child[curChildIdx].description }}
				</div>
				<div class="gallery" ref="gallery">
					<template v-for="(tab, tabIdx) in imageMap">
						<div
							v-for="(item, index) in imageMap[tabIdx].child"
							@click="onGalleryClick(tabIdx, index)"
							:class="{ cur: curTab === tabIdx && curChildIdx === index }"
							class="photo-thumb-item"
						>
							<nio-image
								loader-width="13.3vw"
								style="width:100%;height: 100%"
								:src="cdn(item.thpf_url, '/thumbnail/!100x100r', true)"
							/>
						</div>
					</template>
				</div>
			</float-bottom>
		</template>
	</div>
</template>

<script>
import FloatBottom from '@/components/FloatBottom'
import { supreme } from '@/supreme-core'
import { queryVehicleDetail } from '@/model'
import nativeHybrid from '@/util/nativeHybrid'
import { cdn } from '@/util/imgCdn'
import { sortBannerAppearance, sortBannerInterior } from '@/views1/DetailPage/sortRules'
import util from '@/util/util'

export default {
	name: 'Index',
	components: { FloatBottom },
	data() {
		return {
			tabs: ['外观', '内饰', '瑕疵项', '外观', '内饰', '瑕疵项', '外观', '内饰', '瑕疵项'],

			curTab: 0,
			curChildIdx: 0,

			curPhoto: 0,

			skuCode: supreme.getQueryString('sku_code'),

			car: null,

			focusMode: false
		}
	},
	created() {
		// this.fetchDetail()
	},
	mounted() {
		this.fetchDetail()
	},

	computed: {
		imageMap() {
			if (!this.car) {
				return []
			}
			const list = []
			const map = [
				{
					name: '外观',
					value: 'appearance'
				},
				{
					name: '内饰',
					value: 'interior'
				},
				{
					name: '瑕疵',
					value: 'defects'
				},
				{
					name: '个性选装',
					value: 'personalized'
				}
			]
			map.forEach(item => {
				if (
					this.car.photo[item.value] &&
					this.car.photo[item.value].items &&
					this.car.photo[item.value].items.length
				) {
					let child = this.car.photo[item.value].items
					// 特定的排序规则
					if (item.value === 'appearance') {
						child = sortBannerAppearance(this.car.photo)
					}

					if (item.value === 'interior') {
						child = sortBannerInterior(this.car.photo)
					}
					list.push({
						...item,
						child
					})
				}
			})
			return list
		},
		flatImage() {
			return this.imageMap.reduce((prev, cur) => {
				return prev.concat(
					cur.child.map((child, childIdx) => {
						return {
							image: child.thpf_url,
							childIdx,
							type: cur.name,
							totalIdx: prev.length + childIdx
						}
					})
				)
			}, [])
		},

		curTotalIdx() {
			let totalIdx = 0
			for (let tabIdx = 0; tabIdx < this.imageMap.length; tabIdx += 1) {
				if (tabIdx === this.curTab) {
					totalIdx += this.curChildIdx
					break
				} else {
					totalIdx += this.imageMap[tabIdx].child.length
				}
			}

			return totalIdx
		}
	},
	methods: {
		cdn,

		onSwipe(totalIdx) {
			const oldVal = this.curTotalIdx

			const imageInfo = this.flatImage[totalIdx]

			this.imageMap.forEach((one, tabIdx) => {
				if (one.name === imageInfo.type) {
					this.curTab = tabIdx
					this.curChildIdx = imageInfo.childIdx
				}
			})

			this.updateScrollOffset(oldVal)
		},

		updateScrollOffset(oldVal) {
			this.$nextTick(() => {
				// 回正两个tablist的滚动条位置
				const curTotalIdx = this.curTotalIdx
				if (
					this.$refs.swiper &&
					this.$refs.swiper.swipeTo &&
					typeof this.$refs.swiper.swipeTo === 'function'
				) {
					this.$refs.swiper.swipeTo(curTotalIdx, { immediate: true })
				}

				util.scrollIntoView(
					this.$refs.tabContainer.childNodes[this.curTab],
					curTotalIdx < oldVal ? 'left' : 'right'
				)
				util.scrollIntoView(this.$refs.gallery.childNodes[curTotalIdx], 'left')
			})
		},
		onClickTab(tabIdx) {
			const oldVal = this.curTotalIdx
			this.curTab = tabIdx
			this.curChildIdx = 0

			this.updateScrollOffset(oldVal)
		},
		async fetchDetail() {
			try {
				const { data } = await queryVehicleDetail.get({}, '/' + this.skuCode)

				if (!data || data.result_code !== 'success') {
					throw new Error()
				}
				this.car = data.data

				this.$nextTick(() => {
					// setTimeout(() => {
					if (supreme.getQueryString('type') && supreme.getQueryString('child_idx')) {
						this.imageMap.forEach((one, tabIdx) => {
							if (one.value === supreme.getQueryString('type')) {
								this.curTab = tabIdx

								this.curChildIdx = parseInt(supreme.getQueryString('child_idx'))

								this.updateScrollOffset(0)
							}
						})
					}
					// }, 200)
				})
			} catch (e) {
				// this.$router.push({ path: "/error", query: {message: '网络请求失败'}});
			}
		},
		handleClose() {
			nativeHybrid.closeSyn()
		},
		onGalleryClick(curTab, curChildIdx) {
			this.curTab = curTab
			this.curChildIdx = curChildIdx
			if (
				this.$refs.swiper &&
				this.$refs.swiper.swipeTo &&
				typeof this.$refs.swiper.swipeTo === 'function'
			) {
				this.$refs.swiper.swipeTo(this.curTotalIdx, { immediate: true })
			}
		}
	},

	watch: {
		curTotalIdx(curTotalIdx) {
			localStorage.setItem(
				'previewerTotalIndex',
				JSON.stringify({
					skuCode: this.skuCode,
					index: curTotalIdx
				})
			)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.photo-previewer-page {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: black;
	overflow: hidden;
	display: flex;
	flex-direction: column;

	.tabs-container {
		width: 100%;
		height: 50px;
		overflow: auto hidden;
		padding-left: 20px;
		white-space: nowrap;

		&::-webkit-scrollbar {
			display: none; /* Chrome Safari */
		}

		.tab-item {
			display: inline-flex;
			height: 100%;
			align-items: center;
			margin-right: 30px;
			color: #ffffff;

			&.cur {
				@include subtitle_2(1.4, 500);
			}

			&:not(.cur) {
				@include subtitle_4(1.5, 400, false);
			}
		}
	}

	.gallery {
		padding: 20px 20px 20px;
		white-space: nowrap;
		overflow: auto hidden;

		&::-webkit-scrollbar {
			display: none; /* Chrome Safari */
		}

		.photo-thumb-item {
			display: inline-block;
			width: 50px;
			height: 50px;
			vertical-align: middle;
			position: relative;

			&.cur {
				&:after {
					content: ' ';
					position: absolute;
					inset: 0;
					border: 3px solid $text_basic_active;
				}
			}

			img {
				object-fit: cover;
				object-position: center;
			}

			&:not(:last-child) {
				margin-right: 15px;
			}
		}
	}

	.preview-swiper {
		//transform: translateY(-50%);
		height: 100vh;
	}
	.previewer-container {
		flex: 1;
		overflow: hidden auto;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.photo-desc {
		padding: 14px 20px;
		@include body_2(1.5, 400, false);
		color: #ffffff;
	}

	.gallery-container {
		transition: transform 0.2s ease-in;
		transform: translateY(0);

		width: 100%;
		background-color: black;
	}

	.top-area {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		transition: transform 0.2s ease-in;
		transform: translateY(0);
		z-index: 10;
	}

	&.focus {
		.top-area {
			transform: translateY(-100%);
		}

		.gallery-container {
			transform: translateY(100%);
		}
	}
}
</style>
